import React, { useId } from 'react';

interface NotesStackProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  strokeWidth?: number;
  fillColor?: string;
}

const NotesStack = ({
  size = 24,
  strokeWidth = 1.5,
  fillColor = 'white',
  ...props
}: NotesStackProps) => {
  const clipId = useId();
  return (
    <svg
      viewBox="0 0 18 17"
      width={size}
      height={size}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      {...props}
    >
      <g clipPath={`url(#${clipId})`}>
        <path
          d="M2.99228 7.19428C2.77211 6.31123 2.66202 5.8697 2.74978 5.48957C2.82698 5.1552 3.00805 4.85385 3.26704 4.62871C3.56147 4.37277 4.003 4.26268 4.88605 4.04251L8.24974 3.20385C9.13279 2.98368 9.57432 2.87359 9.95445 2.96135C10.2888 3.03855 10.5902 3.21962 10.8153 3.47861C11.0713 3.77304 11.1813 4.21457 11.4015 5.09762L12.7643 10.5636C12.9845 11.4467 13.0946 11.8882 13.0068 12.2683C12.9296 12.6027 12.7486 12.904 12.4896 13.1292C12.1951 13.3851 11.7536 13.4952 10.8706 13.7154L7.50687 14.554C6.62382 14.7742 6.18229 14.8843 5.80216 14.7965C5.46779 14.7193 5.16644 14.5383 4.94131 14.2793C4.68536 13.9849 4.57527 13.5433 4.3551 12.6603L2.99228 7.19428Z"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M6.40234 4.68337C6.40234 3.77329 6.40234 3.31825 6.57946 2.97064C6.73525 2.66488 6.98385 2.41628 7.28961 2.26049C7.63722 2.08337 8.09226 2.08337 9.00234 2.08337H12.469C13.3791 2.08337 13.8341 2.08337 14.1817 2.26049C14.4875 2.41628 14.7361 2.66488 14.8919 2.97064C15.069 3.31825 15.069 3.77329 15.069 4.68337V10.3167C15.069 11.2268 15.069 11.6818 14.8919 12.0294C14.7361 12.3352 14.4875 12.5838 14.1817 12.7396C13.8341 12.9167 13.3791 12.9167 12.469 12.9167H9.00234C8.09226 12.9167 7.63722 12.9167 7.28961 12.7396C6.98385 12.5838 6.73525 12.3352 6.57946 12.0294C6.40234 11.6818 6.40234 11.2268 6.40234 10.3167V4.68337Z"
        fill={fillColor}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <clipPath id={clipId}>
          <rect
            width="13"
            height="13"
            fill="white"
            transform="translate(0 4.14453) rotate(-14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NotesStack;
